import React from 'react';
import { Redirect } from 'react-router-dom';
// import firebase from '../components/Firebase.js';
// import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';

import { Locale } from '../Localization/CustomLocalization.js';
import { CheckNullValue, CheckObjectBoolean, CheckObjectNumber, CheckObjectStringEmpty, CheckStringEmpty, Delay, DelayUntil } from '../components/GlobalFunctions.js';
import { GlobalSetting } from '../components/GlobalSetting.js';
import { SchoolList } from '../components/NationalQuizEventSignUpSettings.js';
import SchoolListWithDetails from '../components/SchoolListWithDetails.js';

const groupOptions = [
    { id: 1, label: 'Standard 1', value: 1 },
    { id: 2, label: 'Standard 2', value: 2 },
    { id: 3, label: 'Standard 3', value: 3 },
    { id: 4, label: 'Standard 4', value: 4 },
    { id: 5, label: 'Standard 5', value: 5 },
    { id: 6, label: 'Standard 6', value: 6 },
];

//2025.04.16
export default class WorkbookActivationScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.getInitState();   //all states will get refresh everytime enter this page.
    }

    getInitState = () => ({

        modal: {
            email: '',
            emailConfirm: '',
            name: '',
            grade: '',
            groupId: 0,
            group: null,
            classroom: '',
            guardian: '',
            contactNumber: '',

            schoolIndex: -1,
            schoolName: '',
            schoolCode: '',
        },
        // contactNumber_errorMessage: '',

        schoolListArray: [],
        showSelectSchoolListOption: false,

        isLoading: false,
        // errorMessage: '',
        // showModal: false,
    });

    componentDidMount = () => {
        if (this.props.WorkbookInfo === null || this.props.WorkbookInfo === undefined) {
            this.props.CloseAlert();
            this.props.SetWorkbookInfo(null);
            this.setState({
                redirectLink: '/',
                redirect: true,
            });
        }
        this.SettingListToArray();
    }

    SettingListToArray = () => {
        let _schoolListArray = [];
        SchoolList.map((data, key) => {
            return _schoolListArray.push({ value: data, label: data });
        });
        _schoolListArray = [...new Set(_schoolListArray)];  //remove duplicates.
        this.setState({
            schoolListArray: _schoolListArray,
        });
    }

    SetValue = (propertyName = '', value = null) => {
        if (propertyName === '' || CheckNullValue(propertyName) === null || CheckNullValue(value) === null)
            return null;
        let targetModal = this.state.modal;
        switch (propertyName) {
            case 'email': targetModal['email'] = String(value); break;
            case 'emailConfirm': targetModal['emailConfirm'] = String(value); break;
            case 'name': targetModal['name'] = String(value); break;
            case 'guardian': targetModal['guardian'] = String(value); break;
            case 'contactNumber': targetModal['contactNumber'] = String(value); break;
            case 'classroom': targetModal['classroom'] = String(value); break;

            case 'groupId':
                const groupId = CheckObjectNumber(value, 'value');
                targetModal['group'] = value;
                targetModal['groupId'] = groupId;
                targetModal['grade'] = CheckStringEmpty(groupOptions.find(x => x.value === groupId)?.label);
                break;

            case 'school':
                const schoolName = CheckObjectStringEmpty(value, 'value').split('-')[0].trim();
                const findIndex_school = SchoolListWithDetails.findIndex(x => String(x.Name) === schoolName);
                if (findIndex_school > -1) {
                    targetModal['schoolName'] = schoolName;
                    targetModal['schoolIndex'] = findIndex_school;
                    targetModal['schoolCode'] = SchoolListWithDetails[findIndex_school].Kod;
                }
                break;
            default: break;
        }
        this.setState({
            modal: targetModal,
        }, () => {
            if (this.props.isDevMode)
                console.log(`SetValue (${propertyName}) (${JSON.stringify(value)}) \n ${JSON.stringify(targetModal)}`);
        });
    }

    SendEmailPasswordViaApi = async () => {
        let success = false;
        let message = '';

        const schoolCode = CheckStringEmpty(this.state.schoolCode, '0');
        const email = CheckStringEmpty(this.state.loginEmailConfirm);
        if (email !== '') {

            const url = GlobalSetting.ApiUrl + `Api/LearningCentre/Student/ForgotPassword/Request/${email}/${schoolCode}`;
            // Api/LearningCentre/Student/ForgotPassword/Request/{email}/{schoolCode}
            if (this.props.isDevMode)
                console.log(`SendEmailPasswordViaApi \n (${email}) (${schoolCode}) \n ${url}`)

            let done = false;
            await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        // 'Content-Type': 'application/json',
                    },
                })
                .then(res => res.json())
                .then(data => {
                    success = CheckObjectBoolean(data, 'success');
                    if (!success) {
                        message = CheckObjectStringEmpty(data, 'message');
                        if (this.props.isDevMode)
                            console.log('Error', 'api - student forgot password - fetch (failed)\n' + JSON.stringify(data));
                    }
                    done = true;
                })
                .catch(error => {
                    message = error.message;
                    done = true;
                    if (this.props.isDevMode)
                        console.log('Error', 'api - student forgot password - fetch (error)\n' + error.message);
                });
            await DelayUntil(() => done === true);
        }
        return { result: success, error: message };
    }

    CheckValue = () => {
        const targetModal = this.state.modal;
        let errorMessages = [];

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const email = CheckStringEmpty(targetModal?.email);
        if (email === '')
            errorMessages.push('Please do not leave Email field empty.');
        else if (emailRegex.test(email) === false)
            errorMessages.push('Invalid Email address format. Please enter again.');

        const emailConfirm = CheckStringEmpty(targetModal?.emailConfirm);
        if (emailConfirm === '')
            errorMessages.push('Please do not leave Email (Confirm) field empty.');
        else if (emailRegex.test(emailConfirm) === false)
            errorMessages.push('Invalid Email (Confirm) address format. Please enter again.');

        if (email !== '' && emailConfirm !== '') {
            if (email.trim() !== emailConfirm.trim())
                errorMessages.push('Emaill address unmatched. Please enter both email fields correctly.');
        }

        const name = CheckStringEmpty(targetModal?.name);
        if (name === '')
            errorMessages.push('Please do not leave Full Name field empty.');

        const groupId = Number(CheckStringEmpty(targetModal?.groupId));
        if (groupId <= 0)
            errorMessages.push('Please select a Group.');

        const regex = /^\+60\d{2}\d{7}$/;
        const contactNumber = CheckStringEmpty(targetModal?.contactNumber);
        if (contactNumber !== '') {
            if (!regex.test(contactNumber))
                errorMessages.push('Invalid Malaysia phone number format.');
        }

        const isValid = errorMessages.length === 0;
        if (isValid === false) {
            this.props.SetAlert('Validation Failed', <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>{
                errorMessages.map((item) => { return <span>{item}</span> })}</div>);
            if (this.state.isDevMode)
                console.log(`CheckValue (failed) \n ${JSON.stringify(errorMessages)}`);
        }
        return isValid;
    }

    ActivateWorkbookViaApi = async () => {
        const isValid = this.CheckValue();
        if (isValid === false)
            return null;

        this.props.SetLoading('', Locale("msg-activating-workbook", this.props.Locale), false);
        await Delay(1000);

        const modal = this.state.modal;
        const email = CheckObjectStringEmpty(modal, 'Email');
        const name = CheckObjectStringEmpty(modal, 'Name');
        const json = JSON.stringify({
            WorkbookToken: CheckObjectStringEmpty(this.props.WorkbookInfo, 'Token'),
            Email: email,
            Name: name,
            Grade: CheckObjectStringEmpty(modal, 'Grade', 'Other'),
            GroupId: CheckObjectNumber(modal, 'GroupId', 17),
            Classroom: CheckObjectStringEmpty(modal, 'Classroom', 'NA'),
            Guardian: CheckObjectStringEmpty(modal, 'Guardian'),
            ContactNumber: CheckObjectStringEmpty(modal, 'ContactNumber'),
            SchoolCode: CheckObjectStringEmpty(modal, 'SchoolCode'),
            SchoolName: CheckObjectStringEmpty(modal, 'SchoolName'),
        });

        const url = GlobalSetting.ApiUrl + 'Api/LearningCentre/Workbook/Student/Account/RegistrationAndActivation';
        // Api/LearningCentre/Workbook/Student/Account/RegistrationAndActivation
        if (this.props.isDevMode)
            console.log(`ActivateWorkbookViaApi \n (${url}) \n ${json}`)

        let success = false;
        let message = '';
        let done = false;
        await fetch(url,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: json,
            })
            .then(res => res.json())
            .then(data => {
                success = CheckObjectBoolean(data, 'success');
                if (!success) {
                    message = CheckObjectStringEmpty(data, 'message');
                    if (this.props.isDevMode)
                        console.log('Error', 'api - register workbook - post (failed)\n' + JSON.stringify(data));
                }
                done = true;
            })
            .catch(error => {
                message = error.message;
                done = true;
                if (this.props.isDevMode)
                    console.log('Error', 'api - register workbook - post (error)\n' + error.message);
            });
        await DelayUntil(() => done === true);
        await Delay(1000);

        if (success) {
            const workbookName = CheckObjectStringEmpty(this.props.WorkbookInfo, 'Name');
            this.props.SetAlert('Workbook Activation (Success)',
                '<span><b>' + workbookName + '</b> has been activated successfully.<span>'
                + '<div style="display:flex;flex-direction:column;padding: 10px;border: 1px solid gray;border-radius: 5px;width: fit-content;margin: 10px 10px;"><b>' + name + '</b><b>' + email + '</b></div>'
            );
        }
        else {
            this.props.SetAlert('Workbook Activation (Failed)',
                '<span>Unable to activate workbook account.</b>'
                + '<div style="display:flex;flex-direction:column;padding: 10px;border: 1px solid gray;border-radius: 5px;width: fit-content;margin: 10px 10px;"><b>' + name + '</b><b>' + email + '</b></div>'
                + '<div style="padding: 10px;border: 1px solid gray;border-radius: 5px;width: fit-content;margin: 0px 10px;"><b><u>Error:</u></b><br />' + message + '</div>'
            );
        }
    }

    render = () => {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirectLink} />;
        }
        else {
            return (
                <div style={{
                    backgroundColor: 'transparent',
                    // backgroundColor: 'pink', 
                    height: '100%',
                    width: '100%',
                    position: 'absolute',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 0,
                    paddingTop: 10,
                }}>
                    <div className="container" style={{ maxWidth: '550px', backgroundColor: 'transparent', paddingTop: 15, paddingBottom: 15, borderRadius: 5 }}>
                        <div className="row">
                            <aside className="col-sm-12 font-weight-bold">
                                <p style={{
                                    color: 'white', fontSize: 25, textAlign: 'center', fontWeight: 'bold',
                                }}>iKEY Live Quiz</p>
                                <div className="card">
                                    <article className="card-body">
                                        <a href="/" className="float-right btn btn-outline-primary">{Locale("back", this.props.Locale)}</a>
                                        <h4 className="card-title mb-4 mt-1"><b>{Locale("title-workbook-activation", this.props.Locale)}</b></h4>

                                        {/* WorkbookInfo */}
                                        {
                                            this.props.WorkbookInfo ?
                                                <div style={{ padding: 20, border: '3px solid lightgray', borderRadius: 10, marginBottom: 20, textAlign: 'center' }}>
                                                    <span style={{ fontWeight: 'bold', fontSize: 22, color: 'darkorange' }}>{CheckObjectStringEmpty(this.props.WorkbookInfo, 'Name', '-')}</span>
                                                    {
                                                        CheckObjectStringEmpty(this.props.WorkbookInfo, 'LogoUrl') === '' ? null :
                                                            <image src={CheckObjectStringEmpty(this.props.WorkbookInfo, 'LogoUrl')} alt='workbook' />
                                                    }
                                                </div>
                                                : null
                                        }

                                        {/* Email */}
                                        <div className="form-group">
                                            <label>{Locale("your-email", this.props.Locale)}</label>
                                            <input name="email" className="form-control" placeholder={Locale("email-address", this.props.Locale)} type="email"
                                                onChange={(e) => this.SetValue('email', e.target.value)}
                                                value={this.state.modal?.email}
                                            />
                                        </div>

                                        {/* Email (Confirm) */}
                                        <div className="form-group">
                                            <label>{Locale("confirm-your-email", this.props.Locale)}</label>
                                            <input name="emailConfirm" className="form-control" placeholder={Locale("email-address", this.props.Locale)} type="email"
                                                onChange={(e) => this.SetValue('emailConfirm', e.target.value)}
                                                value={this.state.modal?.emailConfirm}
                                            />
                                        </div>

                                        {/* Name */}
                                        <div className="form-group">
                                            <label>{Locale("full-name", this.props.Locale)}</label>
                                            <input name="name" className="form-control" placeholder={Locale("placeholder-full-name", this.props.Locale)} type="text"
                                                onChange={(e) => this.SetValue('name', e.target.value)}
                                                value={this.state.modal?.name}
                                            />
                                        </div>

                                        {/* Group */}
                                        <div className="form-group">
                                            <label>{Locale("label-group", this.props.Locale)}</label>
                                            <Select
                                                id='select-group'
                                                options={groupOptions}
                                                placeholder={Locale("not-specify-group", this.props.Locale)}
                                                onChange={(option) => this.SetValue('groupId', option)}
                                                value={this.state.modal?.group}
                                            />
                                        </div>

                                        {/* Classroom */}
                                        <div className="form-group">
                                            <label>{Locale("your-classroom", this.props.Locale)} ({Locale("optional", this.props.Locale)})</label>
                                            <input name="classroom" className="form-control" placeholder={Locale("placeholder-classroom", this.props.Locale)} type="text"
                                                onChange={(e) => this.SetValue('classroom', e.target.value)}
                                                value={this.state.modal?.classroom}
                                            />
                                        </div>

                                        {/* Guardian */}
                                        <div className="form-group">
                                            <label>{Locale("label-guardian-name", this.props.Locale)} ({Locale("optional", this.props.Locale)})</label>
                                            <input name="name" className="form-control" placeholder={Locale("placeholder-guardian-name", this.props.Locale)} type="text"
                                                onChange={(e) => this.SetValue('guardian', e.target.value)}
                                                value={this.state.modal?.guardian}
                                            />
                                        </div>

                                        {/* Contact Number */}
                                        {/* {
                                            this.state.contactNumber_errorMessage === '' ? null :
                                                <span className='pull-right' style={{ color: 'gray', paddingTop: 5, fontSize: 12 }}>({this.state.contactNumber_errorMessage})</span>
                                        } */}
                                        <div className="form-group">
                                            <label>{Locale("contact-number", this.props.Locale)} ({Locale("optional", this.props.Locale)})</label>
                                            <input name="name" className="form-control" placeholder={Locale("contact-number-sample", this.props.Locale)} type="text"
                                                onChange={(e) => this.SetValue('contactNumber', e.target.value)}
                                                value={this.state.modal?.contactNumber}
                                            />
                                        </div>

                                        {/* School */}
                                        <div className="form-group">
                                            <label>{Locale("label-school", this.props.Locale)} ({Locale("optional", this.props.Locale)})</label>
                                            <Select
                                                id='select-school'
                                                classNamePrefix={'r-select'}
                                                options={this.state.schoolListArray}
                                                menuIsOpen={this.state.showSelectSchoolListOption}
                                                placeholder={Locale("text-school-name", this.props.Locale)}
                                                onInputChange={(e) => {
                                                    let inputText = String(e);
                                                    this.setState({
                                                        showSelectSchoolListOption: inputText.length >= 2 ? true : false,
                                                    });
                                                }}
                                                onChange={(option) => this.SetValue('school', option)}
                                                value={this.state.selectedSchoolName}
                                            />
                                        </div>

                                        {/* <div className="form-group">
                                            <div className='form-warning-text' dangerouslySetInnerHTML={{ __html: Locale("reset-password-warning-text", this.props.Locale) }}></div>
                                        </div> */}

                                        <hr style={{ marginTop: 50 }} />

                                        {/* Button */}
                                        <div className="form-group">
                                            <button type="button" className="btn btn-primary btn-block"
                                                onClick={() => this.ActivateWorkbookViaApi()}
                                            >{Locale("label-activate-workbook", this.props.Locale)}</button>
                                        </div>

                                    </article>
                                </div>
                            </aside>
                        </div>
                    </div>

                    <div style={{ height: '155px', width: '100%' }}>
                        <span>&nbsp;</span>
                    </div>

                    {/* <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{Locale("invalid-info", this.props.Locale)}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body><div dangerouslySetInnerHTML={this.getMessage()}></div></Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.handleCloseModal}>{Locale("close", this.props.Locale)}</Button>
                        </Modal.Footer>
                    </Modal> */}
                </div>
            );
        }
    }
}